import { useTranslation } from "react-i18next";
import { Icon, Popup } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import { formatDate } from "utils/dateHelperFunctions";

type CheckCellProps = {
  setAt: string | null;
  userName: string;
};

export const CheckCell = ({ setAt, userName }: CheckCellProps) => {
  const { t } = useTranslation();

  if (!setAt) return null;

  return (
    <Popup
      content={
        <>
          {t("v8_checked_by", "Checked by")} {userName} {t("v8_on", "on")} {formatDate(setAt, DATE_FORMATS_FNS.dateMonthYearTime)}
        </>
      }
      trigger={<Icon className="check circle green" />}
    />
  );
};
